import React, { createContext, useContext, useState, useEffect } from 'react';
import { useOrganization } from './OrganizationContext';
import { supabase } from '../lib/supabase';

const ProjectContext = createContext();

export function ProjectProvider({ children }) {
  const { currentOrganization } = useOrganization();
  const [projects, setProjects] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load projects when organization changes
  useEffect(() => {
    if (currentOrganization?.id) {
      loadProjects();
    }
  }, [currentOrganization]);

  // Load and set initial project from localStorage
  useEffect(() => {
    if (projects.length > 0) {
      const savedProjectId = localStorage.getItem('currentProjectId');
      if (savedProjectId) {
        const savedProject = projects.find(p => p.id === savedProjectId);
        if (savedProject) {
          setCurrentProject(savedProject);
          setLoading(false);
          return;
        }
      }
      // If no saved project or saved project not found, set first project
      setCurrentProject(projects[0]);
      setLoading(false);
    }
  }, [projects]);

  const loadProjects = async () => {
    try {
      const { data: projects, error } = await supabase
        .from('projects')
        .select('*')
        .eq('organization_id', currentOrganization.id)
        .order('name');

      if (error) throw error;
      setProjects(projects || []);
    } catch (error) {
      console.error('Error loading projects:', error);
    }
  };

  // Update setCurrentProject to save to localStorage
  const handleSetCurrentProject = (project) => {
    setCurrentProject(project);
    if (project?.id) {
      localStorage.setItem('currentProjectId', project.id);
    }
  };

  return (
    <ProjectContext.Provider value={{
      projects,
      currentProject,
      setCurrentProject: handleSetCurrentProject,
      refreshProjects: loadProjects,
      loading
    }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
} 